import { CouncilRegion } from 'shared-components';
import useHash from '../../Hooks/UseHash';
import { FoodLicenseWithDocuments } from '../../Services/InsuranceLicenseService';
import InsuranceDocumentLinks from './InsuranceDocumentLinks';
import { formatUnixDate } from './InsuranceLicenseUtils';

type Props = {
	licenses: FoodLicenseWithDocuments[];
	councilRegions: CouncilRegion[];
	nowUnix: number;
	removingLicenseId: number | null;
	onRemoveLicense: (licenseId: number) => void;
};

export default function FoodLicenseMobileList(props: Props) {
	const { licenses, councilRegions, nowUnix, removingLicenseId, onRemoveLicense } = props;
	const hash = useHash();

	return (
		<div className="insurance-license-mobile-list">
			{licenses.map((license) => {
				const council = councilRegions.find(
					(region) => region.CouncilRegionId === Number(license.FoodLicenseCouncilRegionId ?? 0),
				);
				const isExpired = Number(license.FoodLicenseExpiry ?? 0) <= nowUnix;
				return (
					<div className="insurance-license-mobile-card" key={license.FoodLicenseId}>
						<div className="insurance-license-mobile-card-header">
							<div className="insurance-license-mobile-title">
								{license.FoodLicenseType || 'Food license'}
							</div>
							<div className="insurance-license-mobile-subtitle">
								Expires {formatUnixDate(license.FoodLicenseExpiry) || 'Unknown'}
							</div>
						</div>
						<div className="insurance-license-mobile-row">
							<span className="insurance-license-mobile-label">Council region</span>
							<span>{council?.CouncilRegionName ?? 'Unknown'}</span>
						</div>
						<div className="insurance-license-mobile-row">
							<span className="insurance-license-mobile-label">License number</span>
							<span>{license.FoodLicenseNumber || '-'}</span>
						</div>
						<div className="insurance-license-mobile-row">
							<span className="insurance-license-mobile-label">Expiry</span>
							<span>{formatUnixDate(license.FoodLicenseExpiry) || '-'}</span>
						</div>
						<div className="insurance-license-mobile-row insurance-license-mobile-row--documents">
							<span className="insurance-license-mobile-label">Documents</span>
							<span>
								<InsuranceDocumentLinks documents={license.Documents} hash={hash} />
							</span>
						</div>
						{isExpired ? (
							<div className="insurance-license-mobile-row">
								<span className="insurance-license-mobile-label">Status</span>
								<span className="warning-tag">expired</span>
							</div>
						) : null}
						<div className="insurance-license-mobile-actions">
							<button
								type="button"
								className="insurance-license-action-link"
								disabled={removingLicenseId === license.FoodLicenseId}
								onClick={() => onRemoveLicense(license.FoodLicenseId)}
							>
								{removingLicenseId === license.FoodLicenseId ? 'Removing...' : 'Remove'}
							</button>
						</div>
					</div>
				);
			})}
		</div>
	);
}
